import { render, staticRenderFns } from "./gestaoLPComissionado.vue?vue&type=template&id=506e8c04&scoped=true&"
import script from "./gestaoLPComissionado.vue?vue&type=script&lang=js&"
export * from "./gestaoLPComissionado.vue?vue&type=script&lang=js&"
import style0 from "./gestaoLPComissionado.vue?vue&type=style&index=0&id=506e8c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e8c04",
  null
  
)

export default component.exports